import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { CoreService } from "../../../shared/services/core.service";
import { Merchant } from "src/app/shared/models/merchant";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "src/app/shared/models/Userverify.model";
import { FormsModule } from "@angular/forms";
import { NgStyle, AsyncPipe } from "@angular/common";
import { parsePhoneNumber } from "libphonenumber-js";
import { NgSelectModule } from "@ng-select/ng-select";
@Component({
  selector: "app-guestlogin",
  templateUrl: "./guestlogin.component.html",
  standalone: true,
  imports: [NgStyle, FormsModule, AsyncPipe, NgSelectModule],
})
// Import required modules and classes
export class GuestloginComponent implements OnInit, OnChanges {
  // ViewChild to reference the guestuser element in the template
  @ViewChild("guestuser", { static: false }) private guestuser;
  // Observable for Merchant data
  Merchant$ = this.coreService.Merchant$;
  // Input property to receive the currentMerchant data
  @Input() currentMerchant: Merchant;
  // Input property to indicate if GuestLogin is true or false
  @Input() GuestLogin: boolean;
  // Output property to emit changes in GuestLogin status
  @Output() GuestLoginChange = new EventEmitter<boolean>();
  // Variables to store phone and email information
  phone: string = "";
  email: string = "";
  dialCodes;
  selectedCode;

  // Constructor to initialize class dependencies
  constructor(
    private router: Router,
    private coreService: CoreService,
    private modalService: NgbModal
  ) {}
  ngOnInit(): void {}

  // Lifecycle hook: ngOnChanges
  ngOnChanges(changes: SimpleChanges): void {
    // If GuestLogin is true, initiate login
    if (this.GuestLogin === true) {
      this.coreService.getCountry().subscribe((resp) => {
        if (resp.data) {
          // Set the default merchant country code based on the address.country value
          this.dialCodes = resp.data.map(
            (country) => country.dial_code + " " + country.name
          );
        }
      });

      this.login();
    }
  }

  // Method to attempt login using the login button
  login() {
    // If phone or email is required for guest login, open the modal
    if (
      this.currentMerchant.webapp_settings?.is_guest_phone ||
      this.currentMerchant.webapp_settings?.is_guest_email
    ) {
      this.modalService.open(this.guestuser, {
        centered: true,
        scrollable: true,
      });
      return;
    }
    // Get demo user for guest login
    let user = this.Guestlogin();
    if (user) {
      // this.router.navigate(["/dashboard"]);
    }
  }

  // Method to close the modal and emit GuestLoginChange as false
  close() {
    this.GuestLoginChange.emit(false);
    this.modalService.dismissAll(this.guestuser);
  }

  // Method to collect guest user information from the user
  // if email or phone is required for backend
  collectGuestuserinfo() {
    const cleanedDialCode = this.selectedCode
      .match(/\(\+\d+\)/)?.[0]
      .replace(/[()]/g, "");

    if (
      this.currentMerchant.webapp_settings?.is_guest_phone &&
      (this.phone == "" || !this.isValidNumber(cleanedDialCode + this.phone))
    ) {
      return;
    }
    if (
      this.currentMerchant.webapp_settings?.is_guest_email &&
      (this.email == "" || !this.ValidateEmail(this.email))
    ) {
      return;
    }
    // Get demo user for guest login
    let user = this.Guestlogin(cleanedDialCode + this.phone, this.email);
    if (user) {
      // Dismiss the modal and emit GuestLoginChange as false
      this.modalService.dismissAll(this.guestuser);
      this.GuestLoginChange.emit(false);
      // this.router.navigate(["/dashboard"]);
    }
  }

  // Method to get demo user in case of guest login
  Guestlogin(phone = "", email = "") {
    // Create a new user object
    const user = <User>{};
    // Set user properties
    user.id = "0";
    user.firstName = "";
    user.lastName = "";
    user.userName = "";
    user.dialcode = "";
    user.phoneNumber = phone;
    user.email = email;
    user.account_verified = 1;
    user.guest_access_allowed = 1;
    // Store user details in local storage
    localStorage.setItem("currentUser", JSON.stringify(user));
    // Emit user details using UserSub subject from coreService
    this.coreService.UserSub.next(user);
    // Return the user object
    return user;
  }

  isValidNumber(number) {
    try {
      if (!parsePhoneNumber(number).isValid()) {
        alert("invalid mobile number");
        return false;
      } else return true;
    } catch (ex) {
      alert(ex?.message);
      return false;
    }
  }
  ValidateEmail(Email) {
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!Email.match(mailformat)) {
      alert("invalid Email Adress");
      return false;
    } else return true;
  }
}
